import { combineReducers } from "redux";
import orderReducers from "./orderReducer";
import ReceiptReducer from "./ReceiptReducer";
import routeReducer from "./routeReducer";
import ProcessReducer from "./ProcessReducer";
import updateReducer from "./updateReducer";
const combine = combineReducers({
  orderReducers: orderReducers,
  ReceiptReducer: ReceiptReducer,
  routeReducer: routeReducer,
  ProcessReducer: ProcessReducer,
  updateReducer: updateReducer,
});
export default combine;
